<template>
	<div class="flex-grow flex-column">
		<div class="date-bar flex-center">
			<div class="flex-center date-arrow" @click="dateHandle(-1)"><i class="tf-angle-left"></i></div>
			<span class="date">{{date.getFullYear()}}年{{date.getMonth() + 1}}月</span>
			<div class="flex-center date-arrow" @click="dateHandle(1)"><i class="tf-angle-right"></i></div>
		</div>
		<c-table ref="list" height="grow" fixed-width width-resize>
			<template v-if="scene == 'work'">
				<c-table-column
					type="tree"
					fixed="left"
					width="28"
					name="taskList"
					:leaf-node="({data}) => !data.taskList"
					:width-resize="false"
				>
					<template #default></template>
				</c-table-column>

				<c-table-column
					label="工单编号"
					fixed="left"
					width="140"
				>
					<template #default="{data, nodeData}">
						<c-link v-if="nodeData.level == 0" @click="$emit('workDetail', data)">{{data.work_code}}</c-link>
						<div v-else class="task flex-center-cross">
							<ins>{{data.index}}</ins>
							<span>{{data.process_name}}</span>
						</div>
					</template>
				</c-table-column>
			</template>

			<template v-else>
				<c-table-column
					label="工单编号"
					fixed="left"
					width="140"
				>
					<template #default="{data}">
						{{data.work_code}}
					</template>
				</c-table-column>

				<c-table-column
					label="工序信息"
					fixed="left"
					width="100"
				>
					<template #default="{data}">
						<p>{{data.process_code}}</p>
						<p>{{data.process_name}}</p>
					</template>
				</c-table-column>
			</template>

			<c-table-column
				label="产品信息"
				fixed="left"
				width="140"
			>
				<template #default="{data}">
					<p>{{data.product_code}}</p>
					<p class="flex-center-cross"><span class="ellipsis">{{data.product_name}}</span><span v-if="data.product_spec"> [{{data.product_spec}}]</span></p>
				</template>
			</c-table-column>

			<c-table-column
				label="完成进度"
				fixed="left"
				width="80"
			>
				<template #default="{data}">
					{{data.fine_count}}/{{data.plan_count}}
				</template>
			</c-table-column>

			<c-table-column
				label="开始日期"
				fixed="left"
				width="120"
				:width-resize="false"
			>
				<template #default="{data}">
					<div class="cell flex-column">
						<p><c-link @click="dateHandle(data.plan_start_date)">计划 {{data.plan_start_date.split(' ')[0]}}</c-link></p>
						<p>
							<c-link v-if="data.real_start_date" @click="dateHandle(data.real_start_date)">实际 {{data.real_start_date.split(' ')[0]}}</c-link>
							<span v-else>-</span>
						</p>
					</div>
				</template>
			</c-table-column>

			<c-table-column
				label="结束日期"
				fixed="left"
				width="90"
				:width-resize="false"
			>
				<template #default="{data}">
					<div class="cell flex-column">
						<p>
							<c-link v-if="data.plan_end_date" @click="dateHandle(data.plan_end_date)">{{data.plan_end_date.split(' ')[0]}}</c-link>
							<span v-else>-</span>
						</p>
						<p>
							<c-link v-if="data.real_end_date" @click="dateHandle(data.real_end_date)">{{data.real_end_date.split(' ')[0]}}</c-link>
							<span v-else>-</span>
						</p>
					</div>
				</template>
			</c-table-column>

			<c-table-column
				label="持续时间"
				fixed="left"
				width="70"
				:width-resize="false"
			>
				<template #default="{data}">
					<div class="cell flex-column">
						<p>{{data.plan_duration}}</p>
						<p>{{data.real_duration}}</p>
					</div>
				</template>
			</c-table-column>

			<c-table-column
				v-for="(day, i) in days"
				:key="day.timestamp"
				:label="day.date.toString()"
				width="30"
				align-center
				:width-resize="false"
			>
				<template #default="{data}">
					<div class="cell flex-column">
						<div class="cell-bar" :style="{'background': day.timestamp >= data.plan_timestamp[0] && day.timestamp <= data.plan_timestamp[1] ? '#FFDA4D' : 'none'}"></div>
						<div class="cell-bar" :style="{'background': day.timestamp >= data.real_timestamp[0] && day.timestamp <= data.real_timestamp[1] ? '#00B964' : 'none'}"></div>
					</div>
				</template>
			</c-table-column>
		</c-table>
	</div>
</template>

<script>
	export default {
		props: {
			scene: String
		},

		data() {
			return {
				date: new Date(),
				days: []
			}
		},

		watch: {
			date() {
				this.updateDate();
			}
		},

		mounted() {
			this.updateDate();
		},
		
		methods: {
			updateDate() {
				let last = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
				let length = last.getDate();

				let list = [];
				for (let i = 1; i <= length; i++) {
					let day = new Date(this.date.getFullYear(), this.date.getMonth(), i);
					list.push({
						timestamp: day.getTime(),
						date: day.getDate()
					});
				}
				this.days = list;
			},

			dateHandle(type) {
				if (typeof type == 'string') {
					this.date = new Date(type);
				} else {
					this.date = new Date(this.date.getFullYear(), this.date.getMonth() + type, 1);
				}
			},

			load(data) {
				if (this.scene == 'work') {
					this.$refs.list.load({
						url: '/work/list',
						data: Object.assign({
							view_mode: 1
						}, data),
						dataFormatter: data => {
							data.forEach(work => {
								work.plan_timestamp = this.parseDate(work.plan_start_date, work.plan_end_date);
								work.real_timestamp = this.parseDate(work.real_start_date, work.real_end_date);
								work.taskList && work.taskList.forEach((item, index) => {
									item.index = index + 1;
									item.plan_timestamp = this.parseDate(item.plan_start_date, item.plan_end_date);
									item.real_timestamp = this.parseDate(item.real_start_date, item.real_end_date);
								});
							});
							return data;
						}
					});
				} else {
					this.$refs.list.load({
						url: '/task/list',
						data,
						dataFormatter: data => {
							data.forEach(item => {
								item.plan_timestamp = this.parseDate(item.plan_start_date, item.plan_end_date);
								item.real_timestamp = this.parseDate(item.real_start_date, item.real_end_date);
							});
							return data;
						}
					});
				}
			},

			parseDate(start, end) {
				if (start) {
					start = new Date(start.split(' ') [0] + ' 00:00:00').getTime();
				}
				if (end) {
					end = new Date(end.split(' ') [0] + ' 23:59:59').getTime();
				}
				return [start || null, start ? end || new Date().getTime() : null];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.date {
		font-size: 18px;
		font-weight: bold;

		&-bar {
			height: 44px;
			border-top: 1px solid var(--table-head-border);
			background: var(--table-head-background);
		}

		&-arrow {
			width: 26px;
			height: 26px;
			border: 1px solid #ddd;
			border-radius: 4px;
			margin: 0 10px;
			font-size: 14px;
			background: #fff
			cursor: pointer;

			&:hover {
				border-color: var(--color-main);
				color: var(--color-main);
			}
		}
	}

	.task {
		ins {
			box-sizing: border-box;
			min-width: 18px;
			height: 18px;
			border-radius: 9px;
			padding: 0 4px;
			margin-right: 5px;
			line-height: 18px;
			font-size: 12px;
			font-style: italic;
			text-align: center;
			color: #fff;
			background: #000;
		}
	}

	.cell {
		margin: -5px;
		font-size: 12px;
		color: #333;

		p {
			padding: 5px;

			&:nth-child(2) {
				border-top: var(--table-col-border) var(--table-row-border-style) var(--table-row-border);
			}
		}

		&-bar {
			height: 20px;
		}
	}
</style>